import { Component, OnDestroy } from '@angular/core';
import { ModalBaseDirective } from '$core/base/_modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-navigate-partial-receipts-modal',
  templateUrl: './navigate-partial-receipts-modal.component.html',
  styleUrls: ['./navigate-partial-receipts-modal.component.scss'],
})
export class NavigatePartialReceiptsModalComponent
  extends ModalBaseDirective
  implements OnDestroy
{
  constructor(
    protected modalRef: BsModalRef,
    protected modalService: BsModalService,
    protected translateService: TranslateService
  ) {
    super(modalRef, modalService, translateService);
  }

  public ngOnDestroy() {}
}
